// src/pages/Home.jsx
import React from 'react';
import Seo from '../components/Seo';
import SiteNavJsonLd from '../components/SiteNavJsonLd';

import Hero from '../components/Home/Hero';
import GrowthSection from '../components/Home/GrowthSection';
import WhySection from '../components/Home/WhySection.jsx';
import HowItWorksSection from '../components/Home/HowItWorksSection';
import PricingSection from '../components/Home/PricingSection';
import CtaBoostSection from '../components/Home/CtaBoostSection';
import PartnerLogoSlider from '../components/Home/PartnerLogoSlider.jsx';
import OfferPopup from '../components/Home/OfferPopup';
import LeasePricingSection from '../components/Home/LeasePricingSection.jsx';
import InstagramFeed from '../components/Home/InstagramFeed.jsx';
import LinkInBioProduct from '../components/Home/LinkInBioProduct';

/* globale styles van eerdere secties */
import '../components/Home/Hero.css';
import '../components/Home/GrowthSection.css';
import '../components/Home/WhySection.css';
import '../components/Home/PricingSection.css';
import '../components/Home/CtaBoostSection.css';
import '../components/Home/LeasePricingSection.css';


export default function Home() {
  return (
    <>
      {/* 1. SEO-meta voor de homepage */}
      <Seo
        title="Online Growth Club | Websites & SEO die klanten opleveren"
        description="Wil jij online beter gevonden worden? Bij OnlineGrowthClub.nl bouwen we converterende websites, beheren SEO & SEA en regelen jouw social media — alles gericht op meer klanten, meer groei."
        path="/"
      />

      {/* 2. JSON-LD site-navigation voor sitelinks */}
      <SiteNavJsonLd />

      {/* 3. Pagina-secties */}
      <Hero />
      {/* <PartnerLogoSlider /> */}
      <GrowthSection />
      <LinkInBioProduct />
      <LeasePricingSection />

      <WhySection />
      {/* <HowItWorksSection /> */}
      <CtaBoostSection />

      <PricingSection />
      <InstagramFeed />
      <OfferPopup />
    </>
  );
}
